import React, { useContext } from 'react'
// import { numCol } from '@integec/grid-tools/lib/cols'
// import { OaEventIoHeaders } from './../Headers'
import { rowHeaderRender } from 'core/utils'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { getEventTotalsHeader } from 'marginanalysis/margin-client'
import { getFinalData } from 'marginanalysis/utils'

const EventTotals = props => {
  const {
    width,
    height,
    CLIENT,

    totals = [],
  } = props

  // const marginContext = useContext(MarginAnalysisContext)

  // // const { totals } = whatIf ? WFRetrieveData : retrievedData
  // const { totals } = getFinalData(marginContext, whatIf, isEventPlanner)
  const OaTmpMaTotalsHeaders = getEventTotalsHeader(CLIENT)

  return (
    <Grid
      // ref={this.GridRef}
      // editMode="cell"
      data={totals || []}
      headers={OaTmpMaTotalsHeaders}
      altBgColor="#ebebeb"
      render={virtualizedGridRenderer({
        // autoFixColByKey,
        rowHeaderRender,
        height,
        width,
        headerRowHeight: 30,
      })}
      // onSelectionChange={selected => {
      //   this.selectionChange(selected)
      // }}
      // initialSortOptions={sortOptions}
      // sortOptions={sortOptions}
      // sortEnabled={sortEnabled}
      // isEditable={isEditable}
      selectionType="row"
      selectionMode="single"
    />
  )
}

const EventTotalDefault = props => {
  const { whatIf = false, isEventPlanner = false } = props

  const marginContext = useContext(MarginAnalysisContext)

  // const { totals } = whatIf ? WFRetrieveData : retrievedData
  const { totals } = getFinalData(marginContext, whatIf, isEventPlanner)
  return <EventTotals {...props} totals={totals} />
}

export default EventTotalDefault

export { EventTotals }
